import type { GitSyncProvider } from '@gitbook/app-database';

/**
 * Map a GitSync provider to an appropriate title for a Git provider.
 */
export const GitSyncProviderName: { [type in GitSyncProvider['type']]: string } = {
    github: 'GitHub',
    gitlab: 'GitLab',
    'github-legacy': 'GitHub',
};
